import { useState } from "react";
import { EMPTY_UTM, UTM_FIELDS } from "../utils";

/**
 * UTM 입력 (만들기 · 수정 공통). finalUrl 은 UTM 이 붙은 최종 링크 미리보기.
 */
export function FgUtmFields({ utm, onChange, finalUrl, defaultOpen = false }) {
    const [open, setOpen] = useState(defaultOpen);
    const hasUtm = Object.values(utm).some(v => v.trim());

    return (
        <div className="rounded-xl bg-gray-50 border border-gray-200">
            <button
                type="button"
                onClick={() => setOpen(!open)}
                aria-expanded={open}
                className="w-full flex items-center justify-between px-4 py-3 text-sm font-semibold"
            >
                <span>
                    마케팅 파라미터 (UTM)
                    {hasUtm && <span className="ml-2 rounded-full bg-[var(--mainColor200)] px-2 py-0.5 text-xs text-[var(--mainColor)]">적용됨</span>}
                </span>
                <img src={open ? '/assets/icons/expandLess_000000.svg' : '/assets/icons/expandMore_000000.svg'} alt="" className="w-5 h-5 opacity-60" />
            </button>

            {open &&
                <div className="px-4 pb-4 flex flex-col gap-3">
                    <p className="text-xs text-gray-500">원본 링크에 붙어서 GA·스마트스토어 통계 등 목적지에서 유입을 구분할 수 있습니다. 비워 두면 붙지 않습니다.</p>
                    <div className="grid grid-cols-1 min-[600px]:grid-cols-2 gap-3">
                        {UTM_FIELDS.map(field => (
                            <label key={field.key} className="flex flex-col gap-1">
                                <span className="text-xs font-semibold text-gray-600">{field.label} <span className="font-normal text-gray-400">{field.key}</span></span>
                                <input
                                    list={field.suggestions ? `${field.key}-list` : undefined}
                                    value={utm[field.key]}
                                    onChange={(e) => onChange({ ...utm, [field.key]: e.target.value })}
                                    placeholder={field.placeholder}
                                    maxLength={100}
                                    className="rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm outline-none focus:border-[var(--mainColor)]"
                                />
                                {field.suggestions &&
                                    <datalist id={`${field.key}-list`}>
                                        {field.suggestions.map(s => <option key={s} value={s} />)}
                                    </datalist>
                                }
                            </label>
                        ))}
                    </div>
                    {hasUtm &&
                        <div className="flex justify-between items-center gap-2">
                            <p className="text-xs text-gray-500 break-all min-w-0">
                                {finalUrl ? <>최종 링크: <span className="text-gray-700">{finalUrl}</span></> : '링크를 입력하면 최종 링크가 표시됩니다.'}
                            </p>
                            <button type="button" onClick={() => onChange(EMPTY_UTM)} className="shrink-0 text-xs text-gray-500 underline">초기화</button>
                        </div>
                    }
                </div>
            }
        </div>
    );
}
